import React, { useState, useRef, useEffect } from 'react'
import XLSX from 'xlsx'
import { Col, Alert, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { ButtonGroup, Button } from '@material-ui/core'
import Swal from 'sweetalert2'
import axios from 'axios'
import withReactContent from 'sweetalert2-react-content'
import { useSelector } from 'react-redux'
import DatePicker, { registerLocale } from 'react-datepicker'
import { addDays, set } from 'date-fns'
import es from 'date-fns/locale/es'
import fileDownload from 'js-file-download'
import Table from 'react-bootstrap/Table'

import 'react-datepicker/dist/react-datepicker.css'
import './styles/datepicker.css'
import { urlApiFunctionClientes } from '../../shared/helpers/api/urls'

registerLocale('es', es)

const UrlBackendPi = process.env.REACT_APP_URL_PREP_INFO
const UrlBackendPy = process.env.REACT_APP_URL_PY
const UrlFunctionApp = process.env.REACT_APP_URL_FP
const UrlClientes = urlApiFunctionClientes

const client_id_karri = process.env.REACT_APP_CLIENT_ID_KARRI
const client_secret_karri = process.env.REACT_APP_CLIENT_SECRET_KARRI
const client_id_llego = process.env.REACT_APP_CLIENT_ID_LLEGO
const client_secret_llego = process.env.REACT_APP_CLIENT_SECRET_LLEGO
const client_id = process.env.REACT_APP_CLIENT_ID
const client_secret = process.env.REACT_APP_CLIENT_SECRET

const makeCols = refstr => {
    const o = []
    const C = XLSX.utils.decode_range(refstr).e.c + 1
    for (let i = 0; i < C; ++i) o[i] = { name: XLSX.utils.encode_col(i), key: i }
    return o
}

const SheetJSFT = ['xlsx']
    .map(function (x) {
        return '.' + x
    })
    .join(',')

// eslint-disable-next-line react/prop-types
const UploadFile = ({ path, titulo, client, loading, setLoading }) => {
    const { user: currentUser } = useSelector(state => state.auth)
    const MySwal = withReactContent(Swal)
    const [file, setFile] = useState({
        file: {},
        data: [],
        cols: []
    })
    const [files, setFiles] = useState([])
    const [Enviar, setEnviar] = useState(false)
    const [Nombre, setNombre] = useState('')
    const [Estado, setEstado] = useState('')
    const [recibido, setRecibido] = useState(false)
    const [archivosFinales, setarchivosFinales] = useState([])
    const [Lof, setLof] = useState('')
    const [localParis, setLocalParis] = useState('')
    const [dateManifest, setDateManifest] = useState('')
    const [manifestQ, setManifestQ] = useState('')
    const [buttonEnabled, setButtonEnabled] = useState(false)
    const [disabledActualiza, setDisabledActualiza] = useState(false)
    const target = useRef(null)

    const [region, setRegion] = useState('')
    const [responseRegion, setResponseRegion] = useState('')
    const [archivoCorrecto, setArchivoCorrecto] = useState('')
    const [archivoError, setArchivoError] = useState('')
    const [estimadosCarriles, setEstimadosCarriles] = useState([])
    const [carrilesRespaldo, setCarrilesRespaldo] = useState([])

    useEffect(() => {
        setResponseRegion('')
        setEstimadosCarriles([])
    }, [region])

    useEffect(() => {
        setFiles([])
        setEnviar(false)
        setEstado('')
        setRecibido(false)
        setLof('')
        setDateManifest('')
        setManifestQ('')
        setButtonEnabled(false)
        setRegion('')
    }, [titulo])

    const enabledDays = date => {
        const day = date.getDay()
        return day
    }

    const handleError = (mensaje, titulo, tipo) => {
        MySwal.fire({
            title: titulo,
            icon: tipo,
            text: mensaje,
            confirmButtonText: 'Aceptar'
        }).then(() => {
            window.location.reload()
        })
    }

    const formatDate = (date, format) => {
        const d = new Date(date)
        let month = '' + (d.getMonth() + 1)
        let day = '' + d.getDate()
        const year = d.getFullYear()
        let dateFormated = ''

        if (month.length < 2) {
            month = '0' + month
        }
        if (day.length < 2) {
            day = '0' + day
        }

        if (format === 'us') dateFormated = [year, month, day].join('-')
        else if (format === 'es') dateFormated = [day, month, year].join('-')
        else dateFormated = [day, month, year].join('-')

        return dateFormated
    }

    const handleFile = e => {
        setLoading(true)
        const files = e.target.files
        setEstado('Subiendo Archivo')
        if (files && files[0]) {
            setFiles(files)
            setNombre(files[0].name)
        }
        setLoading(false)
        setEnviar(true)
    }

    function handleChange(e) {
        function toUpperCase(headers) {
            return headers.map(header => header.toUpperCase())
        }
        const files = e.target.files
        setEstado('Subiendo Archivo')
        if (files && files[0]) {
            setLoading(true)
            setFile({ ...file, file: files[0] })
            setNombre(files[0].name)

            const reader = new FileReader()
            const rABS = !!reader.readAsBinaryString

            reader.onload = e => {
                const bstr = e.target.result
                const wb = XLSX.read(bstr, {
                    type: rABS ? 'binary' : 'array',
                    bookVBA: true,
                    cellDates: true,
                    cellNF: false,
                    cellText: false,
                    raw: false
                })
                if (path === 'ManifiestoFalabella') {
                    let hojas = []
                    try {
                        hojas = wb.Workbook.Sheets
                    } catch (error) {
                        handleError('El formato del archivo debe ser .xlsx', 'Error de formato', 'error')
                    }
                    hojas.forEach(hoja => {
                        if (hoja.Hidden !== 0) return 0
                        else {
                            const ws = wb.Sheets[hoja.name]
                            const data = XLSX.utils.sheet_to_json(ws, { defval: ' ' })
                            const dataHeader = toUpperCase(Object.keys(data[0]))
                            try {
                                if (dataHeader.includes('DO') || dataHeader.includes('F12')) {
                                    setFile({ ...file, data: data, cols: makeCols(ws['!ref']) })
                                    setLoading(false)
                                }
                            } catch (error) {
                                console.log('Error al formatear XLSX: ', error)
                            }
                        }
                    })
                } else {
                    const wsname = wb.SheetNames[0]
                    const ws = wb.Sheets[wsname]
                    const data = XLSX.utils.sheet_to_json(ws, { defval: ' ' })
                    setFile({ ...file, data: data, cols: makeCols(ws['!ref']) })
                    setLoading(false)
                }
            }
            if (rABS) {
                reader.readAsBinaryString(files[0])
            } else {
                reader.readAsArrayBuffer(files[0])
            }
            setLoading(false)
            setEnviar(true)
        }
    }

    const handleManifestDate = async date => {
        setManifestQ('')
        setLoading(true)
        setDateManifest(date)
        let url = ''
        let cantidad = ''
        let auth = ''
        if (titulo === 'Manifiesto Ripley Redex Legacy')
            url = UrlBackendPy + 'api/manifest/ripley/redex?date=' + formatDate(date, 'us')
        else if (titulo === 'Manifiesto Ripley Redex')
            url = UrlBackendPy + 'api/manifest/ripley/redex-beta?date=' + formatDate(date, 'us')
        else if (titulo === 'Manifiesto Ripley Sameday Legacy')
            url = UrlBackendPy + 'api/manifest/ripley/sameday?date=' + formatDate(date, 'us')
        else if (titulo === 'Manifiesto Ripley Sameday')
            url = UrlBackendPy + 'api/manifest/ripley/sameday-beta?date=' + formatDate(date, 'us')
        else if (titulo === 'Manifiesto Nclientes')
            url = UrlBackendPy + 'api/manifest/nclientes?date=' + formatDate(date, 'us')
        else if (titulo === 'Manifiesto Shipit' 
            || titulo === 'Manifiesto Karri' 
            || titulo === 'Manifiesto Llego' 
            || titulo === 'Manifiesto Ripley' 
            || titulo === 'Manifiesto Walmart'
            || titulo === 'Manifiesto Dimeiggs'
        ) {
            url = UrlClientes + 'api/manifiestos?cliente=' + client + '&date=' + formatDate(date, 'us') + '&type=conteo'
            auth = 'Basic ' + btoa(client_id + ':' + client_secret)
        }
        await axios
            .get(url, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET,PUT,POST',
                    client: '909802b269dee093387e26c6c7ace636f180eac29f58c7d8009b637c4babf1ce',
                    Authorization: auth
                }
            })
            .then(async response => {
                cantidad = parseInt(response.data)

                if (cantidad === 0) {
                    MySwal.fire({
                        title: 'Info',
                        icon: 'info',
                        text: 'No hay manifiesto disponible para ' + formatDate(date, 'es'),
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#009B78',
                        showDenyButton: false,
                        customClass: {
                            confirmButton: 'spread-font spread-width-100'
                        }
                    }).then(() => {
                        setLoading(false)
                        setDateManifest('')
                        setButtonEnabled(false)
                    })
                } else {
                    setManifestQ(cantidad)
                    setButtonEnabled(true)
                    setLoading(false)
                }
            })
            .catch(error => {
                console.log(error)
                setManifestQ('')
                setLoading(false)
                handleError('Error al consultar la cantidad de manifiestos', 'Error', 'error')
            })
    }

    const handleDownloadBlobFile = (url, filename) => {
        axios
            .get(url, {
                responseType: 'blob',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
            }
            })
            .then(res => {
                fileDownload(res.data, filename)
            })
    }

    const sectorizedManifest = async event => {
        setLoading(true)
        setEstado('Procesando Datos')
        const headers = {
            'Access-Control-Allow-Origin': '*',
            client: '909802b269dee093387e26c6c7ace636f180eac29f58c7d8009b637c4babf1ce',
            'X-Requested-With': 'XMLHttpRequest'
        }
        const formData = new FormData()
        const files = event.target.files
        for (let i = 0; i < files.length; i++) {
            formData.append(`file[${i}]`, files[i])
        }
        try {
            await axios.post(UrlBackendPy + 'api/manifest/sectorizer', formData, { headers }).then(response => {
                const url = response.data.urlFiles
                const filename = url.split('/')[4]
                handleDownloadBlobFile(url, filename)
                setLoading(false)
                MySwal.fire({
                    title: 'Éxito',
                    icon: 'success',
                    text: 'Archivo sectores generado exitosamente',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#009B78',
                    showDenyButton: false,
                    customClass: {
                        confirmButton: 'spread-font spread-width-100'
                    }
                })
            })
        } catch (err) {
            handleError(err, 'Error', 'error')
        }
    }
    const manifestConverter = async () => {
        setLoading(true)
        setEstado('Procesando Datos')
        const headers = {
            'Access-Control-Allow-Origin': '*',
            client: '909802b269dee093387e26c6c7ace636f180eac29f58c7d8009b637c4babf1ce',
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json;charset=utf-8'
        }
        const formData = new FormData()
        const filesData = files
        for (let i = 0; i < filesData.length; i++) {
            formData.append(`file[${i}]`, filesData[i])
        }
        const data = {
            date: formatDate(new Date(), 'us'),
            user: currentUser.displayName,
            env: 'Production',
            lof: Lof || null,
            ft: 0,
            dl: 0,
            dest: [currentUser.email]
        }
        formData.append('data', JSON.stringify(data))
        try {
            let url = ''
            if (titulo === 'Manifiesto Falabella') url = 'api/manifest/falabella'
            else if (titulo === 'Manifiesto Paris') url = 'api/manifest/paris'
            await axios.post(UrlBackendPy + url, formData, { headers }).then(response => {
                const url = response.data.urlFiles
                const filename = url.split('/')[4]
                handleDownloadBlobFile(url, filename)
                setLoading(false)
                MySwal.fire({
                    title: 'Éxito',
                    icon: 'success',
                    text: `${titulo} generado exitosamente`,
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#009B78',
                    showDenyButton: false,
                    customClass: {
                        confirmButton: 'spread-font spread-width-100'
                    }
                }).then(result => {
                    if (result.isConfirmed) {
                        window.location.reload()
                    } else window.location.href = '/planning'
                })
            })
        } catch (err) {
            handleError(err, 'Error', 'error')
        }
    }

    const actualizaBD = async () => {
        setLoading(true)
        setDisabledActualiza(true)
        const data = {
            user: currentUser.displayName,
            env: 'Production',
            dest: [currentUser.email]
        }
        const headers = {
            'Access-Control-Allow-Origin': '*',
            client: '909802b269dee093387e26c6c7ace636f180eac29f58c7d8009b637c4babf1ce',
            'X-Requested-With': 'XMLHttpRequest'
        }

        try {
            const url = 'api/manifest/updatedb'
            await axios.post(url, data, { headers, baseURL: UrlBackendPy }).then(r => {
                setLoading(false)
                if (r.status !== 200) {
                    MySwal.fire({
                        title: 'Error',
                        icon: 'error',
                        text: 'Ocurrió un error al solicitar la actualización, intente más tarde',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#009B78',
                        showDenyButton: false,
                        customClass: {
                            confirmButton: 'spread-font spread-width-100'
                        }
                    })
                } else {
                    MySwal.fire({
                        title: 'Éxito',
                        icon: 'success',
                        text: 'Actualización en cola, se le notificará cuando termine',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#009B78',
                        showDenyButton: false,
                        customClass: {
                            confirmButton: 'spread-font spread-width-100'
                        }
                    })
                }
            })
        } catch (err) {
            handleError(err, 'Error', 'error')
        }
        setTimeout(() => setDisabledActualiza(true), 300000)
    }

    const manifestAutomatized = async () => {
        setLoading(true)
        const data = {
            date: formatDate(dateManifest, 'us'),
            user: currentUser.displayName,
            env: 'Production',
            lof: Lof || null,
            ft: 0,
            dl: 0,
            dest: [currentUser.email]
        }
        const auth = 'Basic ' + btoa(client_id + ':' + client_secret)

        const headers = {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
            client: '909802b269dee093387e26c6c7ace636f180eac29f58c7d8009b637c4babf1ce',
            Authorization: auth,
            'X-Requested-With': 'XMLHttpRequest'
        }
        let url = ''
        let fileUrl = ''
        let filename = ''
        try {
            if (titulo === 'Manifiesto Karri' 
                || titulo === 'Manifiesto Llego' 
                || titulo === 'Manifiesto Shipit' 
                || titulo === 'Manifiesto Ripley' 
                || titulo === 'Manifiesto Walmart'
                || titulo === 'Manifiesto Dimeiggs'
            ) {
                console.log('Nuevo sistema: ' + titulo)
                url =
                    UrlClientes +
                    'api/manifiestos?cliente=' +
                    client +
                    '&date=' +
                    formatDate(dateManifest, 'us') +
                    '&type=manifiesto'
                // console.log('url: ', url)
                // console.log('client_id: ', client_id);
                // console.log('client_secret: ', client_secret);

                await axios
                    .get(url, { headers })
                    .then(response => {
                        if (response.status === 200) {
                            fileUrl = response.data.urlFiles
                            filename = fileUrl.split('/')[4]
                            handleDownloadBlobFile(fileUrl, filename)
                            setLoading(false)
                            setManifestQ('')
                            setDateManifest('')
                            MySwal.fire({
                                title: 'Éxito',
                                icon: 'success',
                                text: 'Manifiesto generado exitosamente',
                                confirmButtonText: 'OK',
                                confirmButtonColor: '#009B78',
                                showDenyButton: false,
                                customClass: {
                                    confirmButton: 'spread-font spread-width-100'
                                }
                            }).then(result => {
                                if (result.isConfirmed) {
                                    window.location.reload()
                                } else window.location.href = '/planning'
                            })
                        } else {
                            setLoading(false)
                            MySwal.fire({
                                title: 'Info',
                                icon: 'info',
                                text: 'No hay manifiestos disponibles para ' + formatDate(dateManifest, 'es'),
                                confirmButtonText: 'OK',
                                confirmButtonColor: '#009B78',
                                showDenyButton: false,
                                customClass: {
                                    confirmButton: 'spread-font spread-width-100'
                                }
                            })
                            setDateManifest('')
                        }
                    })
                    .catch(error => {
                        console.log('error: ', error)
                    })
            } else {
                if (titulo === 'Manifiesto Ripley Redex Legacy') url = 'api/manifest/ripley/redex'
                else if (titulo === 'Manifiesto Ripley Redex') url = 'api/manifest/ripley/redex-beta'
                else if (titulo === 'Manifiesto Ripley Sameday Legacy') url = 'api/manifest/ripley/sameday'
                else if (titulo === 'Manifiesto Ripley Sameday') url = 'api/manifest/ripley/sameday-beta'
                // else if (titulo === 'Manifiesto Shipit') url = 'api/manifest/shipit'
                else if (titulo === 'Manifiesto Nclientes') url = 'api/manifest/nclientes'

                await axios.post(url, data, { headers, baseURL: UrlBackendPy }).then(r => {
                    if (r.status === 204) {
                        setLoading(false)
                        MySwal.fire({
                            title: 'Info',
                            icon: 'info',
                            text: 'No hay manifiestos disponibles para ' + formatDate(dateManifest, 'es'),
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#009B78',
                            showDenyButton: false,
                            customClass: {
                                confirmButton: 'spread-font spread-width-100'
                            }
                        })
                        setDateManifest('')
                    } else {
                        fileUrl = r.data.urlFiles
                        filename = fileUrl.split('/')[4]
                        handleDownloadBlobFile(fileUrl, filename)
                        setLoading(false)
                        setManifestQ('')
                        setDateManifest('')
                        MySwal.fire({
                            title: 'Éxito',
                            icon: 'success',
                            text: 'Manifiesto generado exitosamente',
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#009B78',
                            showDenyButton: false,
                            customClass: {
                                confirmButton: 'spread-font spread-width-100'
                            }
                        }).then(result => {
                            if (result.isConfirmed) {
                                window.location.reload()
                            } else window.location.href = '/planning'
                        })
                    }
                })
            }
        } catch (err) {
            setManifestQ('')
            handleError(err, 'Error', 'error')
        } finally {
            setDateManifest('')
            setManifestQ('')
        }
    }

    function EnviarFile() {
        setLoading(true)
        setEstado('Procesando Datos')
        if (path === 'ManifiestoFalabella') path = path + '/' + Lof
        fetch(UrlBackendPi + path, {
            method: 'POST',
            data: JSON.stringify(file.data, null, 2),
            mode: 'cors',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(file.data, null, 2)
        })
            .then(response => response.json())
            .then(responseJson => {
                setEstado('Creando Archivo Final')
                setarchivosFinales(responseJson)
                responseJson.map(value => {
                    if (value[Object.keys(value)[0]].length > 0) {
                        const fileName = Object.keys(value)[0]
                        const ws = XLSX.utils.json_to_sheet(value[Object.keys(value)[0]], { sheetStubs: true })
                        const wb = XLSX.utils.book_new()
                        const range = XLSX.utils.decode_range(ws['!ref'])
                        for (let r = range.s.r; r <= range.e.r; r++) {
                            for (let c = range.s.c; c <= range.e.c; c++) {
                                const cellName = XLSX.utils.encode_cell({ c: c, r: r })
                                ws[cellName].z = '@'
                            }
                        }
                        XLSX.utils.book_append_sheet(wb, ws, 'sheet')
                        XLSX.writeFile(wb, fileName + '.xlsx')
                        setLoading(false)
                        MySwal.fire({
                            title: 'Éxito',
                            icon: 'success',
                            text: 'Manifiesto generado exitosamente',
                            confirmButtonText: 'Listo',
                            confirmButtonColor: '#009B78',
                            showDenyButton: false,
                            customClass: {
                                confirmButton: 'spread-font spread-width-100'
                            }
                        }).then(result => {
                            if (result.isConfirmed) {
                                window.location.reload()
                            } else window.location.href = '/planning'
                        })
                    }
                    setLoading(false)
                    return true
                })
                setRecibido(true)
                setNombre('')
            })
            .catch(error => {
                MySwal.fire({
                    title: error,
                    icon: 'error',
                    text: 'Hubo un problema al generar el manifiesto, favor contactar a TI',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#009B78',
                    showDenyButton: false,
                    customClass: {
                        confirmButton: 'spread-font spread-width-100'
                    }
                }).then(result => {
                    if (result.isConfirmed) window.location.reload()
                    else window.location.href = '/planning'
                })
            })
    }

    const handlerRegion = async e => {
        let url = UrlFunctionApp + 'api/armadoConsolidado'
        // url = 'https://spread-funciones-diarias.azurewebsites.net/api/armadoConsolidado'
        setRegion(e)
        setLoading(true)
        setEstado('Procesando Datos')

        const data = {
            region: e,
            user: currentUser.email
        }

        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                'Content-Type': 'application/json'
            }
        }

        await axios
            .post(url, data, config)
            .then(response => {
                setLoading(false)
                setResponseRegion(response.data)
                setCarrilesRespaldo(response.data.tabla_carriles)
                setArchivoCorrecto(response.data.archivo_correcto)
                setArchivoError(response.data.archivo_error)
            })
            .catch(error => {
                setLoading(false)
                console.log(error)
            })
    }

    const handleNumberDrivers = async (e, carril, total) => {
        // console.log(e.target.value, carril, total)
        let estimacion = 0
        if (e.target.value === '' || e.target.value === 0) {
            estimacion = 0
        } else {
            estimacion = Math.ceil(total / e.target.value)
        }
        // console.log(`Conductores: ${e.target.value}, Carril: ${carril}, Estimación x chofer: ${estimacion}`);

        estimadosCarriles.map((estimado, index) => {
            if (estimado.carril === carril) {
                estimadosCarriles.splice(index, 1)
            }
        })

        setEstimadosCarriles([
            ...estimadosCarriles,
            { carril: carril, conductores: e.target.value, estimacion: estimacion }
        ])
        return estimacion
    }

    const saveEstimados = async () => {
        // console.log(archivoCorrecto, archivoError);
        let data = {}
        let url = UrlFunctionApp + 'api/armadoLastMileDes'
        setLoading(true)

        if (responseRegion.tabla_carriles.length === estimadosCarriles.length) {
            data = {
                region: region,
                archivo_correcto: archivoCorrecto,
                archivo_error: archivoError,
                estimados: estimadosCarriles,
                tabla_carriles: responseRegion.tabla_carriles,
                folder: 'archivos_planificacion'
            }

            const config = {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                    'Content-Type': 'application/json'
                }
            }

            await axios
                .post(url, data, config)
                .then(response => {
                    const archivo = response.data.archivo_correcto
                    const folder = response.data.folder
                    const container = response.data.container
                    // https://stprocesosdiarios.blob.core.windows.net/myspread/archivos_LastMile/SCL_2024-04-01_09_41_LastMile.xlsx
                    const url = `https://stprocesosdiarios.blob.core.windows.net/${container}/${folder}/${archivo}`
                    try {
                        handleDownloadBlobFile(url, archivo)
                        Swal.fire({
                            title: 'Éxito',
                            icon: 'success',
                            text: 'Archivo generado exitosamente',
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#009B78',
                            showDenyButton: false,
                            customClass: {
                                confirmButton: 'spread-font spread-width-100'
                            }
                        }).then(result => {
                            if (result.isConfirmed) {
                                window.location.reload()
                            } else {
                                window.location.href = '/planning'
                            }
                        })
                    } catch (error) {
                        console.log(error)
                        Swal.fire({
                            title: 'Error',
                            icon: 'error',
                            text: 'Hubo un problema al generar el archivo, favor contactar a TI',
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#009B78',
                            showDenyButton: false,
                            customClass: {
                                confirmButton: 'spread-font spread-width-100'
                            }
                        }).then(result => {
                            if (result.isConfirmed) {
                                window.location.reload()
                            } else {
                                window.location.href = '/planning'
                            }
                        })
                    }
                    setLoading(false)
                    // console.log(response);
                })
                .catch(error => {
                    setLoading(false)
                    console.log(error)
                })
        } else {
            // console.log("The lengths are not equal");
            setLoading(false)
            Swal.fire({
                title: 'Error',
                icon: 'error',
                text: 'Debe ingresar la cantidad de conductores para todos los carriles',
                confirmButtonText: 'OK',
                confirmButtonColor: '#009B78',
                showDenyButton: false,
                customClass: {
                    confirmButton: 'spread-font spread-width-100'
                }
            })
        }
    }

    const handleMixCarriles = async e => {
        // console.log(e.target.value);
        if (e.target.value === '') return
        const carriles = e.target.value.split(',')
        const carril1 = responseRegion.tabla_carriles.find(carril => carril[0] === carriles[0])
        const carril2 = responseRegion.tabla_carriles.find(carril => carril[0] === carriles[1])
        const mixedCarril = `${carril1[0]}-${carril2[0]}`
        const sumNumbers = parseInt(carril1[1]) + parseInt(carril2[1])
        const newCarril = [mixedCarril, sumNumbers]

        // setCarrilesRespaldo([...carrilesRespaldo, carril1, carril2]);

        const updatedCarriles = responseRegion.tabla_carriles.filter(
            carril => carril[0] !== carriles[0] && carril[0] !== carriles[1]
        )
        updatedCarriles.push(newCarril)
        setResponseRegion({ tabla_carriles: updatedCarriles })
        setEstimadosCarriles([])
    }

    const handleSeparateCarriles = async e => {
        const carriles = e.split('-')

        let nuevosCarriles = []
        carriles.map((carrilSeparado, index) => {
            const nuevosCarril = carrilesRespaldo.find(carril => carril[0] === carrilSeparado)
            nuevosCarriles.push(nuevosCarril)
        })
        const updatedCarriles = responseRegion.tabla_carriles.filter(carril => carril[0] !== e)
        nuevosCarriles.map(nuevoCarril => {
            updatedCarriles.push(nuevoCarril)
        })
        setResponseRegion({ tabla_carriles: updatedCarriles })
        setEstimadosCarriles([])
    }

    return (
        <Col className="text-center align-self-center justify-content-md-center" style={{ margin: '10px' }}>
            {path === 'ManifiestoAutomatizado' && (
                <div
                    className="d-inline-flex flex-column align-items-center"
                    // style={buttonEnabled ? { minWidth: '150px' } : { minWidth: '150px', marginTop: '10em' }}
                    style={{ minWidth: '150px' }}>
                    {manifestQ !== '' ? (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    <strong>{manifestQ}</strong> bultos disponibles.
                                </Tooltip>
                            }>
                            <span className="d-inline-block">
                                <DatePicker
                                    locale="es"
                                    required
                                    selected={dateManifest}
                                    onChange={date => handleManifestDate(date)}
                                    todayButton="Seleccionar Hoy"
                                    // filterDate={enabledDays}
                                    placeholderText="Seleccione fecha"
                                    dateFormat="dd/MM/yyyy"
                                    maxDate={addDays(new Date(), 1)}
                                    popperPlacement="top"
                                    className="text-center form-control spread-font customDatePickerWidth"
                                    ref={target}
                                />
                            </span>
                        </OverlayTrigger>
                    ) : (
                        <DatePicker
                            locale="es"
                            required
                            selected={dateManifest}
                            onChange={date => handleManifestDate(date)}
                            todayButton="Seleccionar Hoy"
                            // filterDate={enabledDays}
                            placeholderText="Seleccione fecha"
                            dateFormat="dd/MM/yyyy"
                            maxDate={addDays(new Date(), 1)}
                            popperPlacement="top"
                            className="text-center form-control spread-font customDatePickerWidth"
                            ref={target}
                        />
                    )}
                    {titulo === 'Manifiesto Ripley Sameday'
                        ? !buttonEnabled && (
                              <>
                                  <Alert className="mt-4">
                                      <strong>Fecha seleccionada</strong> representa <strong>día a planificar</strong>
                                  </Alert>
                                  <span style={{ fontSize: '12px' }}>
                                      <strong>ejemplo:</strong> si está planificando la carga que despachará hoy (mismo
                                      día),
                                      <p>debe seleccionar el día de hoy.</p>
                                  </span>
                              </>
                          )
                        : !buttonEnabled && (
                              <>
                                  <Alert className="mt-4">
                                      <strong>Fecha seleccionada</strong> representa <strong>día a planificar</strong>
                                  </Alert>
                                  <span style={{ fontSize: '12px' }}>
                                      <strong>ejemplo:</strong> si está planificando carga del día anterior
                                      <p>para despacho día siguiente, debe seleccionar el día siguiente.</p>
                                  </span>
                              </>
                          )}
                    <Button
                        className="mt-2 spread-font btn btn-primary"
                        variant="contained"
                        style={
                            buttonEnabled
                                ? { backgroundColor: 'rgb(0, 155, 120)', color: 'white', width: '200px' }
                                : { visible: 'hidden', width: '200px' }
                        }
                        onClick={() => {
                            manifestAutomatized()
                        }}
                        disabled={!buttonEnabled || loading}>
                        Generar y Descargar
                    </Button>
                </div>
            )}
            {path === 'ActualizaBD' && (
                <div className="d-inline-flex w-25 flex-column" style={{ minWidth: '150px', marginTop: '10em' }}>
                    <Button
                        className="mt-2 spread-font btn btn-primary"
                        variant="contained"
                        style={{ backgroundColor: 'rgb(0, 155, 120)', color: 'white' }}
                        onClick={() => {
                            actualizaBD()
                        }}
                        disabled={disabledActualiza}>
                        Solicitar Actualización
                    </Button>
                    <Alert className="mt-4">
                        <strong>Recuerda:</strong> debes esperar de 3 a 10 minutos a que el proceso termine.
                    </Alert>
                    <span style={{ fontSize: '12px' }}>
                        serás <strong>notificado vía correo</strong> si finalizó exitosamente y si hubo algún error.
                    </span>
                </div>
            )}
            {path === 'planificacion2' && (
                <>
                    {region === '' && (
                        <div align="center">
                            <table width={'60%'}>
                                <tr>
                                    <td align="center">
                                        <Button
                                            className="mt-2 spread-font btn btn-primary"
                                            variant="contained"
                                            style={{ backgroundColor: 'rgb(0, 155, 120)', color: 'white' }}
                                            onClick={() => {
                                                handlerRegion('SCL')
                                            }}
                                            value="Metropolitana"
                                            disabled={disabledActualiza}>
                                            Metropolitana
                                        </Button>
                                    </td>
                                    <td align="center">
                                        <Button
                                            className="mt-2 spread-font btn btn-primary"
                                            variant="contained"
                                            style={{ backgroundColor: 'rgb(0, 155, 120)', color: 'white' }}
                                            onClick={() => {
                                                handlerRegion('VAP')
                                            }}
                                            value="Valparaiso"
                                            disabled={disabledActualiza}>
                                            Valparaiso
                                        </Button>
                                    </td>
                                    <td align="center">
                                        <Button
                                            className="mt-2 spread-font btn btn-primary"
                                            variant="contained"
                                            style={{ backgroundColor: 'rgb(0, 155, 120)', color: 'white' }}
                                            onClick={() => {
                                                handlerRegion('QRC')
                                            }}
                                            value="O'Higgins"
                                            disabled={disabledActualiza}>
                                            O'Higgins
                                        </Button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    )}
                    {region !== '' && (
                        <>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    width: '80%',
                                    margin: 'auto'
                                }}>
                                <h3>Región: {region}</h3>
                                <button className="btn btn-secondary" onClick={() => setRegion('')}>
                                    Volver
                                </button>
                            </div>
                            <br></br>
                            <div align="center">
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <td align="center">Carril</td>
                                            <td align="center">Bultos</td>
                                            <td align="center">Cantidad de conductores</td>
                                            <td align="center">Estimación por conductor</td>
                                            <td align="center">Juntar con carriles</td>
                                            <td align="center">Separar carriles</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {responseRegion !== ''
                                            ? responseRegion.tabla_carriles.map((value, index) => {
                                                  return (
                                                      <tr key={index}>
                                                          <td align="center">{value[0]}</td>
                                                          <td align="center">{value[1]}</td>
                                                          <td align="center">
                                                              <input
                                                                  type="number"
                                                                  min={1}
                                                                  onChange={e =>
                                                                      handleNumberDrivers(e, value[0], value[1])
                                                                  }
                                                                  required
                                                                  value={estimadosCarriles.map((estimado, index) => {
                                                                      if (estimado.carril === value[0]) {
                                                                          return estimado.conductores
                                                                      }
                                                                  })}
                                                              />
                                                          </td>
                                                          <td align="center">
                                                              {estimadosCarriles.map((estimado, index) => {
                                                                  if (estimado.carril === value[0]) {
                                                                      return estimado.estimacion
                                                                  }
                                                              })}
                                                          </td>
                                                          <td align="center">
                                                              <select
                                                                  onChange={handleMixCarriles}
                                                                  defaultValue={''}
                                                                  value={''}>
                                                                  <option value={''}></option>
                                                                  {responseRegion.tabla_carriles.map(
                                                                      (carril, index) => (
                                                                          <>
                                                                              {carril[0] !== value[0] && (
                                                                                  <option
                                                                                      key={index}
                                                                                      value={`${carril[0]},${value[0]}`}>
                                                                                      {carril[0]}
                                                                                  </option>
                                                                              )}
                                                                          </>
                                                                      )
                                                                  )}
                                                              </select>
                                                          </td>
                                                          <td align="center">
                                                              {value[0].split('-').length > 1 ? (
                                                                  <button
                                                                      className="btn btn-danger"
                                                                      onClick={() => handleSeparateCarriles(value[0])}>
                                                                      Separar
                                                                  </button>
                                                              ) : (
                                                                  ''
                                                              )}
                                                          </td>
                                                      </tr>
                                                  )
                                              })
                                            : ''}
                                    </tbody>
                                </Table>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'end', width: '80%' }}>
                                <br></br>
                                <button className="btn btn-success" onClick={saveEstimados}>
                                    Guardar
                                </button>
                            </div>
                        </>
                    )}
                </>
            )}
            {(path === 'ManifiestoFalabella' || path === 'ManifiestoParis' || path === 'SeparadorSector') && (
                <>
                    {!recibido && (
                        <>
                            <input
                                accept={SheetJSFT}
                                style={{ display: 'none' }}
                                id="contained-button-file"
                                type="file"
                                multiple
                                disabled={Enviar}
                                // eslint-disable-next-line
                                onChange={event => {
                                    titulo == 'Separador por Sector' ? sectorizedManifest(event) : handleFile(event)
                                }}
                            />
                            <label htmlFor="contained-button-file">
                                <img
                                    alt=""
                                    style={{ width: 200 }}
                                    src="https://cdn1.iconfinder.com/data/icons/famous-brand-apps/100/_-04-512.png"
                                />
                                <Button
                                    style={{ backgroundColor: 'rgb(0, 155, 120)' }}
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                    disabled={Enviar}>
                                    {Enviar ? 'Archivo cargado' : 'Seleccionar Archivo'}
                                </Button>
                            </label>
                        </>
                    )}
                    {Enviar && !recibido && (
                        <>
                            {path === 'ManifiestoFalabella' && (
                                <>
                                    <span style={{ fontSize: '18px', paddingTop: '10px' }}>
                                        <p>
                                            Seleccione <strong>local de abastecimiento</strong>:
                                        </p>
                                    </span>
                                    {/* <ButtonGroup
                                        style={{ marginLeft: 20 }}
                                        aria-label="outlined secondary button group"> */}
                                    <Button
                                        variant={Lof === 'LOF1' ? 'contained' : 'outlined'}
                                        onClick={() => {
                                            setLof('LOF1')
                                        }}>
                                        LOF1
                                    </Button>
                                    <Button
                                        variant={Lof === 'LOF2' ? 'contained' : 'outlined'}
                                        onClick={() => {
                                            setLof('LOF2')
                                        }}>
                                        LOF2
                                    </Button>
                                    <Button
                                        variant={Lof === 'FBY' ? 'contained' : 'outlined'}
                                        onClick={() => {
                                            setLof('FBY')
                                        }}>
                                        FBY
                                    </Button>
                                    <Button
                                        variant={Lof === 'HUB XD' ? 'contained' : 'outlined'}
                                        onClick={() => {
                                            setLof('HUB XD')
                                        }}>
                                        HUB XD
                                    </Button>
                                    <Button
                                        variant={Lof === 'HUB XD GSC' ? 'contained' : 'outlined'}
                                        onClick={() => {
                                            setLof('HUB XD GSC')
                                        }}>
                                        HUB XD GSC
                                    </Button>
                                    {/* </ButtonGroup> */}
                                </>
                            )}
                            {/* {
                                path === 'ManifiestoParis' &&
                                <ButtonGroup
                                style={{ marginLeft: 20 }}
                                aria-label="outlined secondary button group">
                                <Button
                                variant={Lof === 'CD PAR RENCA' ? 'contained' : 'outlined'}
                                onClick={() => { setLof('CD PAR RENCA') }}
                                >RENCA</Button>
                                <Button
                                variant={Lof === 'CD PAR BODENOR' ? 'contained' : 'outlined'}
                                onClick={() => { setLof('CD PAR BODENOR') }}
                                >BODENOR</Button>
                                <Button
                                variant={Lof === 'CD PAR SAN IGNACIO' ? 'contained' : 'outlined'}
                                onClick={() => { setLof('CD PAR SAN IGNACIO') }}
                                >SAN IGNACIO</Button>
                                </ButtonGroup>
                            } */}
                            <Button
                                className="mx-3 spread-font btn btn-primary"
                                variant="contained"
                                style={{ backgroundColor: 'rgb(0, 155, 120)', color: 'white' }}
                                onClick={() => {
                                    manifestConverter()
                                }}
                                disabled={
                                    !!(!Lof & (path === 'ManifiestoFalabella')) // || (!Lof && path === 'ManifiestoParis')
                                }>
                                ENVIAR
                            </Button>
                        </>
                    )}
                    {archivosFinales.map((value, index) => {
                        return (
                            <Button
                                key={index}
                                color="primary"
                                variant="contained"
                                style={{ margin: 5, fontWeight: 'bold', backgroundColor: 'rgb(0, 155, 120)' }}
                                disabled={!(value[Object.keys(value)[0]].length > 0)}>
                                {Object.keys(value)[0]}
                            </Button>
                        )
                    })}
                </>
            )}
        </Col>
    )
}

export default UploadFile
